enum OriginationApplicationClientTypeEnum
{
    EXISTING_CLIENT = "EXISTING_CLIENT",
}

export default OriginationApplicationClientTypeEnum;
